import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, FormControl } from '@angular/forms';

@Directive({
  selector: '[minValue]',
  providers: [{ provide: NG_VALIDATORS, useExisting: MinValueValidatorDirective, multi: true }]
})
export class MinValueValidatorDirective implements Validator {
  @Input() minValue: number;
  validate(c: FormControl): { [key: string]: any; } {
    let v = c.value;
    return (v < this.minValue) ? { "minValue": true } : null;
  }
} 



// WEBPACK FOOTER //
// ./src/app/shared/directives/min-value-validator.directive.ts